// extracted by mini-css-extract-plugin
export default {"gradientText":"approval-bulk_gradientText__xlLwn","moreButton":"approval-bulk_moreButton__+IHWp"};